export const MIN_VALID_TEMPERATURE = -80;
export const MAX_VALID_TEMPERATURE = 80;

export const getValidTemperature = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const temperature = Number(value);
  return Number.isFinite(temperature) &&
    temperature >= MIN_VALID_TEMPERATURE &&
    temperature <= MAX_VALID_TEMPERATURE
    ? temperature
    : null;
};

export const isInvalidTemperatureReading = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  getValidTemperature(value) === null;

export const temperatureReadingClass = (value) =>
  isInvalidTemperatureReading(value) &&
  String(localStorage.getItem("role") || "").replace(/\s+/g, "").toLowerCase() === "systemadmin"
    ? "invalid-temperature-reading"
    : "";

export const formatTemperatureReading = (value, fallback = "") => {
  const temperature = getValidTemperature(value);
  return temperature === null ? fallback : temperature;
};

export const temperatureReadingMarkup = (value) =>
  `<span class="${temperatureReadingClass(value)}">${formatTemperatureReading(value)}</span>`;

export const sanitizeTemperatureReadings = (record) => {
  const sanitizedRecord = { ...record };
  [
    "sensorAValue",
    "sensorBValue",
    "tempA",
    "tempB",
    "tempAStart",
    "tempBStart",
    "tempAEnd",
    "tempBEnd",
  ].forEach((field) => {
    if (Object.prototype.hasOwnProperty.call(sanitizedRecord, field)) {
      sanitizedRecord[field] = getValidTemperature(sanitizedRecord[field]);
    }
  });
  return sanitizedRecord;
};
